import { sortBy } from 'lodash';
import { Serving } from '../types';

export const sortServings = (servings: Serving[] = []) => {
  const allHaveOrder = servings.every((serving) => typeof serving.order === 'number');

  if (allHaveOrder) {
    return sortBy(servings, (serving) => serving.order);
  }

  return sortBy(servings, (serving) => serving.size);
};
